<div class="dashboard-container" [class.sidebar-collapsed]="!isSidebarOpen">
    <!-- Header - Full Width -->
    <div class="header">
        <div class="header-left">
            <!-- Logo -->

            <div class="logo">
                <button (click)="toggleMenu()" mat-icon-button>
                    <mat-icon>menu</mat-icon>
                </button>

                <div class="logo-icon" (click)="goHome()">
                    <img ngSrc="./assets/img/logo-dark.png" alt="LOGO" height="80" width="510"/>
                </div>
            </div>
        </div>

        <div class="header-center">

        </div>

        <div class="header-right">
            <div class="user-profile">
                <mat-icon class="text-grey" style="font-size: 45px; height: 80px; width: 80px">account_circle</mat-icon>
            </div>
        </div>
    </div>

    <!-- Content Area -->
    <div class="content-area">
        <!-- Sidebar -->
        <div class="sidebar">
            <!-- Navigation -->
            <nav class="nav-menu">
                <div class="nav-item"
                     *ngFor="let item of navItems"
                     [class.active]="item.active"
                     (click)="onNavItemClick(item)">
                    <mat-icon class="text-grey">{{item.icon}}</mat-icon>
                    <span class="nav-label">{{ item.label }}</span>
                </div>
            </nav>
        </div>

        <!-- Main Content -->
        <div class="main-content-dark">
            <!-- Dashboard Cards -->
            <div class="container">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
